import React from 'react';
import { IAuditoriaFinanceiraResultado } from '../interfaces/IAuditoriaFinanceira';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaFinanceiraResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria Financeira (Resgate e Vínculo Obrigatório de IRRF sobre Aplicações Financeiras) não é
// um tributo — é uma auditoria complementar que reúne três análises (Resgate sem IRRF pareado,
// Receita Financeira de Competência Mensal Ausente e Conciliação Consolidada de Fim de Mês).
// Segue o mesmo padrão de seção própria já usado para Saldos Bancários, Depreciação e Caixa.
const AuditoriaResumoFinanceira: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias =
    (resultado.resgatesSemIrrf?.length || 0) +
    (resultado.resgatesSemIof?.length || 0) +
    (resultado.receitaMensalAusente?.length || 0) +
    (resultado.conciliacaoConsolidada?.length || 0);

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Resgate e Vínculo Obrigatório de IRRF sobre Aplicações Financeiras</h3>
      <p className='text-muted'>
        Auditoria complementar — resgates sem retenção de IRRF/IOF pareada, receita financeira de competência mensal ausente
        e lançamentos consolidados de fim de mês (indício de falta de conciliação). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-end'>Impacto Financeiro Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_FINANCEIRA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria Financeira — Resgate e IRRF</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} conta{totalOcorrencias === 1 ? '' : 's'}/competência{totalOcorrencias === 1 ? '' : 's'} com indício identificado no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>IRRF e IOF não retidos em resgates de aplicação financeira (risco fiscal)</div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Rendimento de aplicação financeira não contabilizado (perda financeira real)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoFinanceira;
